export default __webpack_public_path__ + "static/media/gpc-logo.a59267b7.png";